import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import i18n from '../../../i18n';
import {useTranslation} from 'react-i18next';
import {DateTimePicker, LocalizationProvider} from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt';
import frLocale from 'date-fns/locale/fr';
import {Select, initTE} from 'tw-elements';
import {Combobox} from '@headlessui/react';
import {v4 as uuidv4} from 'uuid';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import {XMarkIcon} from '@heroicons/react/24/outline';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import Spinner from '../../../components/Spinner';
import {
    getDadosProposta,
    getOficinas,
    getProspects,
    PostDadosContaPesquisa,
    postProposta,
    getPropostaId,
    getContactosProspect,
    getRepresentantes,
    getTiposContratoManutencao,
    getDuracaoContractoManutencao,
    getHorasAnoManutencao,
    getLubrificantesManutencao,
    getMarcas,
    getCategoriasArtigos,
    getTiposPropostas,
    getEstabelecimentos,
    getNegocios,
    getMoedas,
    getLinguas,
    gerarRevisao,
    enviarEmailOrcamento,
    getStatusOrcamento,
    getPrazosEntrega,
    getValidadesProposta,
    getPdf,
    getPontosAnalise,
} from '../../../pages/requests';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponent from '../../Selects/SelectComponent';
import Linha from './Linha';
import {useRef} from 'react';
import MultiSelect from '../../Selects/MultiSelect';
import Geral from './Geral';
import Pagamento from './Pagamento';
import Garantia from './Garantia';
import Manutencao from './Manutencao';
import moment from 'moment';
import Retoma from './Retoma';
import {getCondicoesPagamento, getGarantias, getGarantiasMotor, getGarantiasPower, getLayouts, getLocaisEntrega, getTextosDespedida, getTextosIntro} from '../api';
import axios from 'axios';
import ExitForm from '../../ExitFormModal';
import EmailPropostaModal from './EmailPropostaModal';
import Status from './Status';
import PopupPDF from '../../Prospects/Form/ContaCorrente/popUpPdf';
import PA from './PA';
import ContratoFinanceiro from './ContratoFinanceiro';
import LoadingModal from '../../LoadingModal';

function NovaProposta({
    setGuardar,
    guardar,
    imprimirProposta,
    setImprimirProposta,
    enviarEmailProposta,
    setEnviarEmailProposta,
    gerarRevisaoProposta,
    setGerarRevisaoProposta,

    setOnChangeForm,

    setShowForm,

    setEditarProposta,
    editarProposta,

    proposta,

    idNegocio,
    // historyData,

    showOutrasInfo,
    setShowOutrasInfo,
    openTab,
    setOpenTab,
    onChangeForm,
    // filtro status
    filtroDtStatus,
    setFiltroDtStatus,
    filtroUtilizador,
    setFiltroUtilizador,
    filtroAcao,
    setFiltroAcao,
    filtroDestinatarios,
    setFiltroDestinatarios,
    filtroEmail,
    setFiltroEmail,
}) {
    //
    const FORMATO_DATA = 'YYYY-MM-DD';

    const history = useHistory();
    const {t} = useTranslation();
    const [dataI, setDataI] = useState(null);
    const [dataF, setDataF] = useState(null);
    const [linhas, setLinhas] = useState([
        {
            idLinha: Math.random() * 999999,
            nome: '',
            referencia: '',
            stock: 0,
            preco: 0,
            desconto: 0,
            quantidade: 0,
            acessorios: [],
            acessoriosExtra: [],
            atributos: [],
        },
    ]);

    const [propostaCarregada, setPropostaCarregada] = useState(null);

    const [responsaveis, setResponsaveis] = useState([]);
    const {acessos, utilizador, rep, userRepresentante, oficina, formatarNumero} = useContext(Context);
    const [prospects, setProspects] = useState([]);
    var today = new Date();
    initTE({Select});

    //// Variaveis com os valores preenchidos do formulario //////
    // Dados Base
    const [estabelecimentoVenda, setEstabelecimentoVenda] = useState(oficina);
    const [tipoOrcamento, setTipoOrcamento] = useState(null);
    // const [mercado, setMercado] = useState(null); //Eixo AX7 - Mercado
    const [dataProposta, setDataProposta] = useState({
        startDate: null,
        endDate: null,
    });
    const [prospectEscolhido, setProspectEscolhido] = useState(null);
    const [negocio, setNegocio] = useState(null);
    const [moeda, setMoeda] = useState(null);
    const [lingua, setLingua] = useState(null);

    const [estabelecimentoExpedicao, setEstabelecimentoExpedicao] = useState(oficina);
    const [representante, setRepresentante] = useState(userRepresentante);
    // const [area, setArea] = useState(null); //Eixo AX5 - Area
    const [contactoR, setContactoR] = useState([]);
    // Geral
    const [layout, setLayout] = useState(null);
    const [textoIntro, setTextoIntro] = useState(null);
    const [textoDespedida, setTextoDespedida] = useState(null);
    const [validadeProposta, setValidadeProposta] = useState('');
    const [localEntrega, setLocalEntrega] = useState(null);
    const [prazoEntrega, setPrazoEntrega] = useState('');
    const [contactoAssinatura, setContactoAssinatura] = useState('');
    // const [imagemProduto, setImagemProduto] = useState('');
    const [observacoes, setObservacoes] = useState('');
    const [dataPdf, setDataPdf] = useState('');
    const [acrescimoIVA, setAcrescimoIVA] = useState(false);
    const [ecovalor, setEcovalor] = useState(false);
    const [ecolub, setEcolub] = useState(false);
    const [ecobat, setEcobat] = useState(false);
    // Pagamento
    const [condicoesPagamento, setCondicoesPagamento] = useState(null);
    const [descricaoOutros, setDescricaoOutros] = useState('');
    // Status
    const [statusOcamento, setStatusOcamento] = useState([]);
    // Garantia
    const [garantia, setGarantia] = useState(null);
    const [garantiaPower, setGarantiaPower] = useState(null);
    const [garantiaMotor, setGarantiaMotor] = useState(null);
    // Manutenção
    const [tipoContrato, setTipoContrato] = useState(null);
    const [lubrificantes, setLubrificantes] = useState(null);
    const [duracaoContrato, setDuracaoContrato] = useState(null);
    const [horasAno, setHorasAno] = useState(null);
    const [localTrabalho, setLocalTrabalho] = useState('');
    const [loadingM, setLoadingM] = useState(false);

    // Retoma
    const [linhasRetoma, setLinhasRetoma] = useState([
        {
            id: Math.floor(Math.random() * 999999),
            categoria: '',
            marca: '',
            modelo: '',
            nSerie: '',
            matricula: '',
            horas: '',
            ano: '',
            valor: 0,
        },
    ]);

    // PA
    const [pontosAnalise, setPontosAnalise] = useState([
        {
            id: Math.floor(Math.random() * 999999),
            pAnalise: null,
            precoBruto: 0,
        },
    ]);

    ////       Arrays     //////////////////
    // Dados base
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [tiposOrcamentos, setTiposOrcamentos] = useState([]);
    // const [mercados, setMercados] = useState([]); //Eixo AX7 - Mercado
    // const [areas, setAreas] = useState([]); //Eixo AX5 - Area
    const [negocios, setNegocios] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [linguas, setLinguas] = useState([]);
    const [moedas, setMoedas] = useState([]);
    // Geral
    const [arrayLayout, setArrayLayout] = useState([]);
    const [textosIntro, setTextosIntro] = useState([]);
    const [arrayTextoDespedida, setArrayTextoDespedida] = useState([]);
    const [arrayLocalEntrega, setArrayLocalEntrega] = useState([]);

    const [arrayPrazosEntrega, setArrayPrazosEntrega] = useState([]);
    const [arrayValidadeProposta, setArrayValidadeProposta] = useState([]);
    // Pagamento
    const [arrayCondicoesPagamento, setArrayCondicoesPagamento] = useState([]);
    // Garantia
    const [arrayGarantia, setArrayGarantia] = useState([]);
    const [arrayGarantiaPower, setArrayGarantiaPower] = useState([]);
    const [arrayGarantiaMotor, setArrayGarantiaMotor] = useState([]);
    // Manutenção
    const [arrayTipoContrato, setArrayTipoContrato] = useState([]);
    const [arrayLubrificantes, setArrayLubrificantes] = useState([]);
    const [arrayDuracaoContrato, setArrayDuracaoContrato] = useState([]);
    const [arrayHorasAno, setArrayHorasAno] = useState([]);
    //

    const [arrayPontosAnalise, setArrayPontosAnalise] = useState([]);

    //

    const [loading, setLoading] = useState(false);

    // Validações
    const [validacaoEstabVenda, setValidacaoEstabVenda] = useState(false);
    const [validacaoTipo, setValidacaoTipo] = useState(false);
    const [validacaoMercado, setValidacaoMercado] = useState(false);
    const [validacaoData, setValidacaoData] = useState(false);
    const [validacaoProspect, setValidacaoProspect] = useState(false);
    const [validacaoNegocio, setValidacaoNegocio] = useState(false);
    const [validacaoMoeda, setValidacaoMoeda] = useState(false);
    const [validacaoLingua, setValidacaoLingua] = useState(false);
    const [validacaoEstabExpedicao, setValidacaoEstabExpedicao] = useState(false);
    const [validacaoRep, setValidacaoRep] = useState(false);
    const [validacaoAreaIndustria, setValidacaoAreaIndustria] = useState(false);
    const [validacaoContacto, setValidacaoContacto] = useState(false);
    const [validacaoEquipamento, setValidacaoEquipamento] = useState(false);
    const [validacaoCondicoesPagamento, setValidacaoCondicoesPagamento] = useState(false);

    const [validacaoModelo, setValidacaoModelo] = useState(false);
    const [validacaoNserie, setValidacaoNserie] = useState(false);
    const [validacaoMatricula, setValidacaoMatricula] = useState(false);
    const [validacaoHoras, setValidacaoHoras] = useState(false);
    const [validacaoAno, setValidacaoAno] = useState(false);
    const [validacaoValor, setValidacaoValor] = useState(false);

    //

    // Contrato financeiro

    const [condicoesPagamentoCF, setCondicoesPagamentoCF] = useState('');
    const [duracao, setDuracao] = useState('');
    const [carencia, setCarencia] = useState('');
    const [numRendas, setNumRendas] = useState('');
    const [portesMes, setPortesMes] = useState('');
    const [seguroCivil, setSeguroCivil] = useState('');
    const [taxaNominal, setTaxaNominal] = useState('');
    const [entradaInicial, setEntradaInicial] = useState('');
    const [rendaMensal, setRendaMensal] = useState('');
    const [valorResidual, setValorResidual] = useState('');
    const [seguroCasco, setSeguroCasco] = useState('');
    const [despesasContrato, setDespesasContrato] = useState('');

    //Arrays contrato financeiro

    // const [arrayCondicoesPagamento, setArrayCondicoesPagamento] = useState([]);
    const [arrayDuracao, setArrayDuracao] = useState([]);
    const [arrayCarencia, setArrayCarencia] = useState([]);
    const [arrayNumRendas, setArrayNumRendas] = useState([]);
    const [arrayPortesMes, setArrayPortesMes] = useState([]);
    const [arraySeguroCivil, setArraySeguroCivil] = useState([]);
    const [arrayTaxaNominal, setArrayTaxaNominal] = useState([]);
    const [arrayEntradaInicial, setArrayEntradaInicial] = useState([]);
    const [arrayRendaMensal, setArrayRendaMensal] = useState([]);
    const [arrayValorResidual, setArrayValorResidual] = useState([]);
    const [arraySeguroCasco, setArraySeguroCasco] = useState([]);
    const [arrayDespesasContrato, setArrayDespesasContrato] = useState([]);

    const [marcas, setMarcas] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [showExitModal, setShowExitModal] = useState(false);

    const idProposta = proposta?.id;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleLeavePage = event => {
        debugger;
        if (onChangeForm) {
            setShowExitModal(true);
            if (event?.preventDefault) {
                event?.preventDefault();
            }
            return false;
        }
        return true;
    };

    useEffect(() => {
        const unblock = history.block(handleLeavePage);

        window.addEventListener('beforeunload', handleLeavePage);

        return () => {
            unblock();
            window.removeEventListener('beforeunload', handleLeavePage);
        };
    }, [onChangeForm]);

    useEffect(() => {
        if (imprimirProposta) {
            handleGetPdf();
        }
    }, [imprimirProposta]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        if (prospectEscolhido) {
            //Filtrar os negócios de acordo com o cliente selecionado
            getNegocios(0, 9999, lang, signal, false, false, '', [], 0, '', [], prospectEscolhido.value, '', '', 0, '', '', '', '', '', '', '')
                .then(res => {
                    if (res.data.success) {
                        setNegocios(
                            res.data.negocios.map(n => {
                                return {...n, value: n.num, label: n.nome};
                            }),
                        );
                    }
                })
                .catch(error => {
                    if (!axios.isCancel(error)) console.log(error);
                });
        } else {
            setNegocios([]);
        }

        return () => {
            controller.abort();
        };
    }, [prospectEscolhido]);

    useEffect(() => {
        if (history.location.state?.negocio) {
            var _negocio = history.location.state?.negocio;
            console.log(_negocio, "negocio");
            setEstabelecimentoVenda(_negocio.estabelecimento);
            setEstabelecimentoExpedicao(_negocio.estabelecimento);

            setProspectEscolhido({value: _negocio.codEmpresa, label: _negocio.empresa});
            debugger;
            // getProspectClientes(_negocio.codEmpresa).then(res => {
            //     debugger;
            //     setLingua(res.data.clientes[0].lingua);
            // });
            // const val =
            getProspectClientes(_negocio.codEmpresa);
            // setLingua(prospects.clientes[0].lingua)

            setTipoContrato({value: _negocio.tipoContrato.value, label: _negocio.tipoContrato.label});
            setLubrificantes({value: _negocio.lubrificantes.value, label: _negocio.lubrificantes.label});
            setDuracaoContrato({value: _negocio.duracaoContrato.value, label: _negocio.duracaoContrato.label});
            setHorasAno({value: _negocio.horasAno.value, label: _negocio.horasAno.label});
            setLocalTrabalho(_negocio.localTrabalho);

            setContactoR(_negocio.contactos);
            setMoeda({value: _negocio.divisa.value, label: _negocio.divisa.label});
            setRepresentante(_negocio.responsavel);

            setNegocio({..._negocio, value: _negocio.num, label: _negocio.nome});

            setDuracao(_negocio.duracao);
            setCarencia(_negocio.carencia);
            setNumRendas(_negocio.numRendas);
            setPortesMes(_negocio.portesMes);
            setSeguroCivil(_negocio.seguroCivil);
            setTaxaNominal(_negocio.taxaNominal);
            setEntradaInicial(_negocio.entradaInicial);
            setRendaMensal(_negocio.rendaMensal);
            setValorResidual(_negocio.valorResidual);
            setSeguroCasco(_negocio.seguroCasco);
            setDespesasContrato(_negocio.despesasContrato);

            // setArea(_negocio.industria);

            setLinhas(
                _negocio.artigos.map(a => {
                    return {
                        ...a,
                        preco: a.preco,
                        quantidade: 1,
                        desconto: 0,
                        acessoriosExtra: [],
                        atributos: [],
                        acessos: [],
                    };
                }),
            );
        }
    }, [history]);

    useEffect(() => {
        if (history.location.state?.negocio && prospects.length != 0) {
            console.log(prospects[0].lingua);
            setLingua(prospects[0].lingua);
        }
    }, [history, prospects]);

    const handleChildChange = (e, id) => {
        const updatedData = [...linhas];
        updatedData[id] = e;
        setLinhas(updatedData);
    };

    useEffect(() => {
        if (proposta) {
            debugger;
            setLoading(true);
            getPropostaId(proposta.id, lang)
                .then(res => {
                    if (res.data.success == true) {
                        debugger;
                        console.log(res.data);
                        setPropostaCarregada(res.data.proposta);

                        setEstabelecimentoVenda(res.data.proposta.estabelecimentoVenda);
                        setEstabelecimentoExpedicao(res.data.proposta.estabelecimentoExpedicao);

                        setProspectEscolhido({
                            ...res.data.proposta.cliente,
                            value: res.data.proposta.cliente.codigoCliente,
                            label: res.data.proposta.cliente.nomeCliente,
                        });

                        setLingua(res.data.proposta.lingua);
                        setMoeda(res.data.proposta.moeda);
                        setNegocio({...res.data.proposta.negocio, value: res.data.proposta.negocio.num, label: res.data.proposta.negocio.nome});

                        // setArea(res.data.proposta.area);
                        // setMercado(res.data.proposta.mercado);

                        setRepresentante(res.data.proposta.representante);

                        setTipoOrcamento(res.data.proposta.tipoOrcamento);

                        setContactoR(res.data.proposta.contactos);

                        // const dataI = res.data.proposta.data;
                        // const partes = dataI.split("/");
                        // const dataFormatada = `${partes[2]}-${partes[1]}-${partes[0]}`;
                        setDataProposta({
                            startDate: res.data.proposta.data,
                            endDate: res.data.proposta.data,
                        });
                        // setDataProposta(res.data.proposta.data);

                        /// Geral
                        setLayout(res.data.proposta.layout);
                        setTextoIntro(res.data.proposta.textoIntroducao);
                        setTextoDespedida(res.data.proposta.textoDespedida);
                        setPrazoEntrega(res.data.proposta.prazoEntrega);
                        setLocalEntrega(res.data.proposta.localEntrega);
                        setValidadeProposta(res.data.proposta.validadeProposta);
                        setContactoAssinatura(res.data.proposta.contactoAssinatura);
                        // setImagemProduto(res.data.proposta.imagemProduto);
                        setObservacoes(res.data.proposta.observacoes);

                        setAcrescimoIVA(res.data.proposta.acresceIVA);
                        setEcovalor(res.data.proposta.ecovalor);
                        setEcolub(res.data.proposta.ecolub);
                        setEcobat(res.data.proposta.ecobat);

                        /// Pagamento
                        setCondicoesPagamento(res.data.proposta.condicoesPagamento);
                        setDescricaoOutros(res.data.proposta.condicoesPagamento.dep);

                        /// Garantia
                        setGarantia(res.data.proposta.garantia);
                        setGarantiaMotor(res.data.proposta.garantiaMotor);
                        setGarantiaPower(res.data.proposta.garantiaPowerTrain);

                        /// Manutenção
                        setTipoContrato(res.data.proposta.tipoContrato);
                        setLubrificantes(res.data.proposta.lubrificantes);
                        setDuracaoContrato(res.data.proposta.duracaoContrato);
                        setHorasAno(res.data.proposta.horasAno);
                        setLocalTrabalho(res.data.proposta.localTrabalho);

                        setLinhas(res.data.proposta.linhas);

                        setDuracao(res.data.proposta.contratoFinanceiroDuracao);
                        setCarencia(res.data.proposta.contratoFinanceiroCarencia);
                        setNumRendas(res.data.proposta.contratoFinanceiroNRendas);
                        setPortesMes(res.data.proposta.contratoFinanceiroPortes);
                        setSeguroCivil(res.data.proposta.contratoFinanceiroSegRepCivil);
                        setTaxaNominal(res.data.proposta.contratoFinanceiroTaxaNominal);
                        setEntradaInicial(res.data.proposta.contratoFinanceiroEntradaInicial);
                        setRendaMensal(res.data.proposta.contratoFinanceiroRendaMensal);
                        setValorResidual(res.data.proposta.contratoFinanceiroValorResidual);
                        setSeguroCasco(res.data.proposta.contratoFinanceiroSeguroCasco);
                        setDespesasContrato(res.data.proposta.contratoFinanceiroDespesasContrato);

                        // Retoma
                        setLinhasRetoma(
                            res.data.proposta.linhasRetoma.map(l => {
                                return {...l, id: Math.floor(Math.random() * 999999)};
                            }),
                        );
                        // PA
                        setPontosAnalise(
                            res.data.proposta.pontosAnalise?.map(l => {
                                return {...l, id: Math.floor(Math.random() * 999999)};
                            }),
                        );
                    } else {
                        res.data.errorMessages.map(m => {
                            toast.error(m, {
                                position: 'top-right',
                                autoClose: 6000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: 'light',
                            });
                        });
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [proposta]);
    console.log(proposta, 'proposta');
    function handleGetPdf() {
        setLoading(true);
        let vcrtyp = 3;
        let id = proposta.id;
        getPdf(id, vcrtyp)
            .then(function (response) {
                if (response.data.success) {
                    const byteCharacters = atob(response.data.pdf);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], {type: 'application/pdf'});
                    const blobSizeInMB = blob.size / (1024 * 1024);
                    debugger;
                    if (blobSizeInMB > 1) {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `${proposta.id}.pdf`;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    } else {
                        // setDataPdf(blob);
                        setDataPdf(response.data.pdf);
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const adicionarNovaLinha = () => {
        const novaLinha = {
            idLinha: Math.random() * 999999,
            nome: '',
            referencia: '',
            stock: 0,
            preco: 0,
            desconto: 0,
            quantidade: 0,
            acessorios: [],
            acessoriosExtra: [],
            atributos: [],
        };
        setLinhas([...linhas, novaLinha]);
    };

    const eliminarLinha = id => {
        const novasLinhas = linhas.filter(linha => linha.idLinha !== id);
        setLinhas(novasLinhas);
    };

    const [ivas, setIVAs] = useState([]);
    const memoizedData = useMemo(() => {
        return linhas.map((item, index) => {
            return (
                <Linha
                    validacaoEquipamento={validacaoEquipamento}
                    setValidacaoEquipamento={setValidacaoEquipamento}
                    editarProposta={editarProposta}
                    handleChildChange={item => handleChildChange(item, index)}
                    linhaP={item}
                    key={index}
                    totalLinhas={linhas.length}
                    linha={index + 1}
                    adicionarNovaLinha={adicionarNovaLinha}
                    eliminarLinha={id => eliminarLinha(id)}
                    ivas={ivas}
                    aluguer={tipoOrcamento?.aluguer ?? false}
                />
            );
        });
    }, [linhas, editarProposta, tipoOrcamento]);

    useEffect(() => {
        setLoading(true);
        var promises = [];

        promises.push(
            getEstabelecimentos(lang).then(res => {
                setEstabelecimentos(res.data.estabelecimentos);
            }),
        );

        promises.push(
            getRepresentantes(lang).then(res => {
                setResponsaveis(res.data.representantes);
            }),
        );

        promises.push(
            getCategoriasArtigos(lang).then(res => {
                if (res.data.success) {
                    setCategorias(res.data.categorias);
                }
            }),
        );

        promises.push(
            getMarcas(lang).then(res => {
                setMarcas(res.data.marcas);
            }),
        );

        promises.push(
            getProspects(0, 9999, lang, utilizador).then(function (response) {
                //PROSPECTS
                var comps = [];
                response.data.clientes.forEach(element => {
                    const prospects = {
                        ...element,
                        value: element.codigoCliente,
                        label: element.nomeCliente,
                    };
                    comps.push(prospects);
                });
            }),
        );

        promises.push(
            getTiposPropostas(lang).then(res => {
                setTiposOrcamentos(res.data.tiposOrcamento);
            }),
        );

        promises.push(
            getMoedas(lang).then(res => {
                setMoedas(res.data.moedas);
            }),
        );

        promises.push(
            getLinguas(lang).then(res => {
                setLinguas(res.data.linguas);
            }),
        );

        // getDadosProposta(lang).then(function (response) {
        //     // var comps = [];
        //     // response.data.tipoOrcamento.forEach(element => {
        //     //     const tipoOrcamento = {
        //     //         value: element.id,
        //     //         label: element.desc,
        //     //     };
        //     //     comps.push(tipoOrcamento);
        //     // });
        //     // setTiposOrcamentos(comps);
        //     // let orcamentoTemp = comps.find(x => x.value === 'SQN');
        //     // setTipoOrcamento(orcamentoTemp);

        //     var comps2 = [];

        //     comps2 = response.data.ax5.map(element => {
        //         return {
        //             value: element.id,
        //             label: element.desc,
        //         };
        //     });
        //     setAreas(comps2);
        // });

        if (!proposta) {
            setDataProposta({
                startDate: moment(today).format(FORMATO_DATA),
                endDate: moment(today).format(FORMATO_DATA),
            });
        }

        //LAYOUT
        promises.push(
            getLayouts(lang).then(res => {
                setArrayLayout(res.data.layouts);
            }),
        );

        promises.push(
            getTextosIntro(lang).then(res => {
                setTextosIntro(res.data.textosIntro);
            }),
        );

        //DESPEDIDA
        promises.push(
            getTextosDespedida(lang).then(res => {
                setArrayTextoDespedida(res.data.textosDespedida);
            }),
        );

        //LOCAL
        promises.push(
            getLocaisEntrega(lang).then(res => {
                setArrayLocalEntrega(res.data.locaisEntrega);
            }),
        );

        //PAGAMENTO
        promises.push(
            getCondicoesPagamento(lang).then(res => {
                setArrayCondicoesPagamento(res.data.condicoesPagamento);
            }),
        );

        //GARANTIA
        promises.push(
            getGarantias(lang).then(res => {
                setArrayGarantia(res.data.garantias);
            }),
        );

        //GARANTIA POWER TRAIN
        promises.push(
            getGarantiasPower(lang).then(res => {
                setArrayGarantiaPower(res.data.garantiasPower);
            }),
        );

        //GARANTIA MOTOR
        promises.push(
            getGarantiasMotor(lang).then(res => {
                setArrayGarantiaMotor(res.data.garantiaMotor);
            }),
        );

        //CONTRATO
        promises.push(
            getTiposContratoManutencao(lang).then(res => {
                setArrayTipoContrato(res.data.tipoContratoManutencao);
            }),
        );

        //LUBRIFICANTES
        promises.push(
            getLubrificantesManutencao(lang).then(res => {
                setArrayLubrificantes(res.data.lubrificantesManutencao);
            }),
        );

        //DURACAO
        promises.push(
            getDuracaoContractoManutencao(lang).then(res => {
                debugger
                const sortedData = res.data.duracaoContractoManutencao.sort((a, b) => a.value - b.value);

                setArrayDuracaoContrato(sortedData);
            }),
        );

        //HORAS ANO
        promises.push(
            getHorasAnoManutencao(lang).then(res => {
                setArrayHorasAno(res.data.horasAnoManutencao);
            }),
        );
        //STATUS
        promises.push(
            getStatusOrcamento(lang).then(res => {
                setStatusOcamento(res.data);
            }),
        );

        //LOCAL
        promises.push(
            getPrazosEntrega(lang).then(res => {
                setArrayPrazosEntrega(res.data.prazosEntrega);
            }),
        );

        //LOCAL
        promises.push(
            getValidadesProposta(lang).then(res => {
                setArrayValidadeProposta(res.data.validadesProposta);
            }),
        );
        //LOCAL
        promises.push(
            getPontosAnalise(lang).then(res => {
                setArrayPontosAnalise(res.data.pontosAnalise);
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    function getProspectClientes(pesquisa) {
        if (pesquisa.length >= 3) {
            setProspects([]);

            getProspects(0, 9999, lang, pesquisa).then(response => {
                setProspects(
                    response.data.clientes.map(c => {
                        return {
                            ...c,
                            value: c.codigoCliente,
                            label: c.nomeCliente,
                        };
                    }),
                );
            });
        }
    }

    const [totalLinhas, setTotalLinhas] = useState(0);
    const [subtotal, setSubtotal] = useState(0);
    const [totalDesconto, setTotalDesconto] = useState(0);
    const [totalIVA, setTotalIVA] = useState(0);
    useEffect(() => {
        setSubtotal(
            linhas
                .map(element => Number(element?.preco) * Number(element?.quantidade) + element.acessoriosExtra.map(ex => ex.quantidade * ex.preco).reduce((a1, a2) => a1 + a2, 0))
                .reduce((a1, a2) => a1 + a2, 0),
        );

        setTotalDesconto(
            linhas
                .map(
                    element =>
                        Number(element?.preco) * Number(element?.quantidade) * (element?.desconto / 100) +
                        element.acessoriosExtra.map(ex => ex.preco * ex.quantidade * (ex.desconto / 100)).reduce((a1, a2) => a1 + a2, 0),
                )
                .reduce((a1, a2) => a1 + a2, 0),
        );

        setTotalIVA(
            linhas
                .map(element => Math.round((element?.preco * element?.quantidade - element?.preco * element?.quantidade * (element?.desconto / 100)) * (element?.iva?.iva ?? 0) * 100) / 100)
                .reduce((a1, a2) => a1 + a2, 0),
        );
    }, [linhas]);

    useEffect(() => {
        if (prospectEscolhido) {
            getContactosProspect(prospectEscolhido.value, lang).then(function (response) {
                var comps = [];
                response.data.contactos?.forEach(element => {
                    const contacto = {
                        value: element.id,
                        label: element.nome + '' + element.apelido + ' - ' + element.telemovel,
                    };
                    comps.push(contacto);
                });
                setContactos(comps);
            });
        }
    }, [prospectEscolhido]);

    async function GuardarProposta() {
        var podeGravar = true;
        setLoadingM(true)
        if (!estabelecimentoVenda) {
            setValidacaoEstabVenda(true);
            podeGravar = false;
        }
        if (!tipoOrcamento) {
            setValidacaoTipo(true);
            podeGravar = false;
        }
        // if (!mercado) {
        //     setValidacaoMercado(true);
        //     podeGravar = false;
        // }
        if (!dataProposta.startDate) {
            setValidacaoData(true);
            podeGravar = false;
        }
        if (!prospectEscolhido) {
            setValidacaoProspect(true);
            podeGravar = false;
        }

        if (!negocio) {
            setValidacaoNegocio(true);
            podeGravar = false;
        }
        if (!lingua) {
            setValidacaoLingua(true);
            podeGravar = false;
        }
        if (!moeda) {
            setValidacaoMoeda(true);
            podeGravar = false;
        }

        if (!estabelecimentoExpedicao) {
            setValidacaoEstabExpedicao(true);
            podeGravar = false;
        }
        if (!representante) {
            setValidacaoRep(true);
            podeGravar = false;
        }
        // if (!area) {
        //     setValidacaoAreaIndustria(true);
        //     podeGravar = false;
        // }

        if (contactoR.length === 0) {
            setValidacaoContacto(true);
            podeGravar = false;
        }

        if (!condicoesPagamento) {
            setValidacaoCondicoesPagamento(true);
            podeGravar = false;
        }

        if (linhas[0]?.referencia == '') {
            linhas[0].validacaoEquipamento = true;
            podeGravar = false;
        }
        debugger;

        linhas
            .filter(l => l.referencia !== '')
            .forEach(l => {
                if (l.quantidade === 0) {
                    l.validacaoQuantidade = true;
                    podeGravar = false;
                }
            });

        setLinhas(
            linhas.map(l => {
                return {...l, id: Math.random() * 999999};
            }),
        );

        linhasRetoma
            .filter(l => l.categoria !== '' && l.marca !== '')
            .forEach(l => {
                if (l.modelo === '') {
                    setValidacaoModelo(true);
                    podeGravar = false;
                }
                if (l.nSerie === '') {
                    setValidacaoNserie(true);
                    podeGravar = false;
                }
                if (l.matricula === '') {
                    setValidacaoMatricula(true);
                    podeGravar = false;
                }
                if (l.horas === '') {
                    setValidacaoHoras(true);
                    podeGravar = false;
                }
                if (l.ano === '') {
                    setValidacaoAno(true);
                    podeGravar = false;
                }
                if (l.valor === 0) {
                    setValidacaoValor(true);
                    podeGravar = false;
                }
            });

        if (!podeGravar) {
            setLoadingM(false)
            toast.warn(t('camposObrigatorios'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        const guardarConclusaoWS = new Promise((resolve, reject) => {
            postProposta(
                lang,
                proposta?.id ?? '',
                estabelecimentoVenda,
                estabelecimentoExpedicao,
                tipoOrcamento,
                '', //Referencia
                {codigoCliente: prospectEscolhido.value},
                {value: '1'}, //estado
                dataProposta.startDate,
                // area,
                // mercado,
                condicoesPagamento,
                descricaoOutros,
                representante,
                negocio,
                moeda,
                lingua,

                layout,
                textoIntro,
                textoDespedida,
                // prazoEntrega.startDate,
                prazoEntrega,
                localEntrega,
                // validadeProposta.startDate,
                validadeProposta,
                contactoAssinatura,
                // imagemProduto,
                observacoes,
                acrescimoIVA,
                ecovalor,
                ecolub,
                ecobat,

                garantia,
                garantiaPower,
                garantiaMotor,

                tipoContrato,
                lubrificantes,
                duracaoContrato,
                horasAno,
                localTrabalho,

                contactoR,
                linhas,
                linhasRetoma.filter(l => l.categoria && l.marca),
                pontosAnalise.filter(l => l.pAnalise),
                condicoesPagamentoCF,
                duracao,
                carencia,
                numRendas,
                portesMes,
                seguroCivil,
                taxaNominal,
                entradaInicial,
                rendaMensal,
                valorResidual,
                seguroCasco,
                despesasContrato,
            ).then(res => {
                if (res.data.success) {
                    resolve('Sucesso!');
                } else {
                    let mensagem = res.data.errorMessages;
                    let resposta = '';
                    if (mensagem) resposta = mensagem;
                    if (!mensagem) resposta = t('toastErro');
                    reject(resposta);
                }
            });
        });

        toast.promise(
            guardarConclusaoWS,
            {
                // pending: t('a_guardar'),
                success: {
                    render({data}) {
                        setLoadingM(false)
                        setShowForm(false);
                        return proposta?.id ? t('negocioAlterado') : t('negocioCriado');
                    },
                },
                error: {
                    render({data}) {
                        setLoadingM(false)
                        return data;
                    },
                },
            },
            {autoClose: 5000},
        );

        // para poder alterar states de qualquer coisa tenho que ter a promise concluida, senão o toast nunca desaparece
        // por isso tenho de fazer um await
        await Promise.allSettled([guardarConclusaoWS]);
    }
    useEffect(async () => {
        if (guardar) {
            await GuardarProposta();
            setGuardar(false);
        }
    }, [guardar]);

    // Quando clicamos no botão de gerar revisao
    useEffect(async () => {
        if (gerarRevisaoProposta) {
            debugger;

            const guardarConclusaoWS = new Promise((resolve, reject) => {
                postProposta(
                    lang,
                    '', //proposta?.id ?? '',
                    estabelecimentoVenda,
                    estabelecimentoExpedicao,
                    tipoOrcamento,
                    '', //Referencia
                    {codigoCliente: prospectEscolhido.value},
                    {value: '1'}, //estado
                    dataProposta.startDate,
                    // area,
                    // mercado,
                    condicoesPagamento,
                    descricaoOutros,
                    representante,
                    negocio,
                    moeda,
                    lingua,

                    layout,
                    textoIntro,
                    textoDespedida,
                    // prazoEntrega.startDate,
                    prazoEntrega,
                    localEntrega,
                    // validadeProposta.startDate,
                    validadeProposta,
                    contactoAssinatura,
                    // imagemProduto,
                    observacoes,
                    acrescimoIVA,
                    ecovalor,
                    ecolub,
                    ecobat,

                    garantia,
                    garantiaPower,
                    garantiaMotor,

                    tipoContrato,
                    lubrificantes,
                    duracaoContrato,
                    horasAno,
                    localTrabalho,

                    contactoR,
                    linhas,
                    linhasRetoma.filter(l => l.categoria && l.marca),
                    pontosAnalise.filter(l => l.pAnalise),

                    condicoesPagamentoCF,
                    duracao,
                    carencia,
                    numRendas,
                    portesMes,
                    seguroCivil,
                    taxaNominal,
                    entradaInicial,
                    rendaMensal,
                    valorResidual,
                    seguroCasco,
                    despesasContrato,
                ).then(res => {
                    if (res.data.success) {
                        resolve('Sucesso!');
                    } else {
                        let mensagem = res.data.errorMessages;
                        let resposta = '';
                        if (mensagem) resposta = mensagem;
                        if (!mensagem) resposta = t('toastErro');
                        reject(resposta);
                    }
                });
            });

            toast.promise(
                guardarConclusaoWS,
                {
                    pending: t('a_guardar'),
                    success: {
                        render({data}) {
                            setShowForm(false);
                            return proposta?.id ? t('negocioAlterado') : t('negocioCriado');
                        },
                    },
                    error: {
                        render({data}) {
                            return data;
                        },
                    },
                },
                {autoClose: 2000},
            );
            // gerarRevisao(proposta.id, lang).then(res => {
            //     debugger;
            //     if (res.data.success) {
            //     } else {
            //         res.data.errorMessages.map(m =>
            //             toast.error(m, {
            //                 position: 'top-right',
            //                 autoClose: 5000,
            //             }),
            //         );
            //     }
            // });

            // para poder alterar states de qualquer coisa tenho que ter a promise concluida, senão o toast nunca desaparece
            // por isso tenho de fazer um await
            await Promise.allSettled([guardarConclusaoWS]);
            setGerarRevisaoProposta(false);
        }
    }, [gerarRevisaoProposta]);

    // Quando clicamos no botão de enviar email
    // useEffect(() => {
    //     if (enviarEmailProposta) {
    //         enviarEmailOrcamento(proposta?.id, lang).then(res => {
    //             debugger;
    //         });
    //         setEnviarEmailProposta(false);
    //     }
    // }, [enviarEmailProposta]);

    return (
        <>
            {dataPdf != '' && (
                <PopupPDF
                    back={() => {
                        setDataPdf('');
                        setImprimirProposta(false);
                    }}
                    id={dataPdf}></PopupPDF>
            )}
            {loadingM && <LoadingModal />}
            {enviarEmailProposta && (
                <EmailPropostaModal
                    proposta={propostaCarregada}
                    cancelar={() => setEnviarEmailProposta(false)}
                    enviar={(assunto, corpo, emails) => {
                        const guardarConclusaoWS = new Promise((resolve, reject) => {
                            enviarEmailOrcamento(propostaCarregada.id, lang, assunto, corpo, emails)
                                .then(res => {
                                    if (res.data.success) {
                                        resolve('Sucesso!');
                                    } else {
                                        let mensagem = res.data.errorMessages;
                                        let resposta = '';
                                        if (mensagem) resposta = mensagem;
                                        if (!mensagem) resposta = t('toastErro');
                                        reject(resposta);
                                    }
                                })
                                .finally(() => {});
                        });
                        toast.promise(
                            guardarConclusaoWS,
                            {
                                success: {
                                    render({data}) {
                                        setEnviarEmailProposta(false);
                                        return t('enviado');
                                    },
                                },
                                pending: t('aEnviar'),
                                error: {
                                    render({data}) {
                                        return data;
                                    },
                                },
                            },
                            {autoClose: 2000},
                        );
                    }}
                />
            )}

            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {!loading && openTab === 1 && (
                <>
                    <form className="mt-4">
                        <div className="grid gap-6 mb-3 md:grid-cols-2">
                            <div>
                                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('estabelecimentoVenda')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={estabelecimentos}
                                    value={estabelecimentoVenda}
                                    onChange={e => {
                                        setValidacaoEstabVenda(false);
                                        setEstabelecimentoVenda(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoEstabVenda ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                            <div>
                                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('tipoOrcamento')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={tiposOrcamentos}
                                    value={tipoOrcamento}
                                    onChange={e => {
                                        setValidacaoTipo(false);
                                        setTipoOrcamento(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoTipo ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                            {/* <div>
                                <label
                                    htmlFor="visitors"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('mercado')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={mercados}
                                    value={mercado}
                                    onChange={e => {
                                        setValidacaoMercado(false);
                                        setMercado(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoMercado ? (
                                    <small className="text-red-500">
                                        {t('preenchaCampos')}
                                    </small>
                                ) : null}
                            </div> */}
                        </div>
                        <div className="grid gap-6 mb-3 md:grid-cols-3">
                            <div>
                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('data')}*
                                </label>
                                <Datepicker
                                    disabled={!editarProposta}
                                    displayFormat={FORMATO_DATA}
                                    useRange={false}
                                    asSingle={true}
                                    value={dataProposta}
                                    onChange={newValue => {
                                        setValidacaoData(false);
                                        setDataProposta(newValue);
                                        setOnChangeForm(true);
                                    }}
                                    inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                        !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                    }`}
                                />
                                {validacaoData ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>

                            <div>
                                <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('prospectCliente')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={prospects}
                                    placeholder={t('pesquisa')}
                                    value={prospectEscolhido}
                                    onChange={e => {
                                        setProspectEscolhido(e);
                                        setLingua(e.lingua);
                                        setMoeda(e.divisa);
                                        setValidacaoProspect(false);
                                        setValidacaoLingua(false);
                                        setValidacaoMoeda(false);
                                        setNegocio(null);
                                        setCondicoesPagamento(e.condicoesPagamento);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    onInputChange={e => getProspectClientes(e)}
                                />
                                {validacaoProspect ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                            <div className="grid gap-6 mb-3 md:grid-cols-5">
                                <div className={`${propostaCarregada ? 'md:col-span-4' : 'md:col-span-5'}`}>
                                    <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        {t('negocio')}*
                                    </label>
                                    <SelectComponent
                                        isDisabled={!editarProposta}
                                        options={negocios}
                                        value={negocio}
                                        onChange={e => {
                                            setValidacaoNegocio(false);
                                            setNegocio(e);
                                            setEstabelecimentoVenda(e.estabelecimento);
                                            setEstabelecimentoExpedicao(e.estabelecimento);
                                            setOnChangeForm(true);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                    />
                                    {validacaoNegocio ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                                </div>
                                {propostaCarregada && (
                                    <div>
                                        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            {t('versao')}
                                        </label>
                                        <input
                                            type="text"
                                            value={propostaCarregada.revisao}
                                            className={`bg-gray-50 dark:bg-gray-800  border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                            disabled={true}
                                        />
                                    </div>
                                )}
                            </div>
                            <div>
                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('moeda')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={moedas}
                                    value={moeda}
                                    onChange={e => {
                                        setValidacaoMoeda(false);
                                        setMoeda(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoMoeda ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                            <div>
                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('lingua')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={linguas}
                                    value={lingua}
                                    onChange={e => {
                                        setValidacaoLingua(false);
                                        setLingua(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoLingua ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                            <div>
                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('estabelecimentoExpedicao')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={estabelecimentos}
                                    value={estabelecimentoExpedicao}
                                    onChange={e => {
                                        setValidacaoEstabExpedicao(false);

                                        setEstabelecimentoExpedicao(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoEstabExpedicao ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>

                            {/* <div>
                                <label
                                    htmlFor="website"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('area')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={areas}
                                    value={area}
                                    onChange={e => {
                                        setValidacaoAreaIndustria(false);
                                        setArea(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoAreaIndustria ? (
                                    <small className="text-red-500">
                                        {t('preenchaCampos')}
                                    </small>
                                ) : null}
                            </div> */}
                        </div>
                        <div className="grid gap-6 mb-3 md:grid-cols-2">
                            <div>
                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('representante')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarProposta}
                                    options={responsaveis}
                                    value={representante}
                                    onChange={e => {
                                        setValidacaoRep(false);
                                        setRepresentante(e);
                                        setOnChangeForm(true);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                />
                                {validacaoRep ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                            <div>
                                <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                                    {t('contacto')}*
                                </label>
                                <MultiSelect
                                    isDisabled={!editarProposta}
                                    options={contactos}
                                    value={contactoR}
                                    onChange={e => {
                                        setValidacaoContacto(false);
                                        setOnChangeForm(true);
                                        setContactoR(e);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('selecioneOpcao')}
                                />
                                {validacaoContacto ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                            </div>
                        </div>
                        <div className="relative min-h-[180px] overflow-x-auto shadow-md sm:rounded-[8px] mb-4">
                            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 z-20">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                    <tr>
                                        <th scope="col" className="px-1 py-3"></th>
                                        <th scope="col" className="px-1 py-3"></th>
                                        <th scope="col" className="px-1 py-3"></th>
                                        <th scope="col" className="px-6 py-3 w-64 ">
                                            {t('referencia')}
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            {t('descricao')}
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            {t('stock')}
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            {t('encomendadoFornecedor')}
                                        </th>
                                        {!(tipoOrcamento?.aluguer ?? false) && (
                                            <th scope="col" className="px-6 py-3">
                                                {t('ecovalor')}
                                            </th>
                                        )}
                                        {/* {!(tipoOrcamento?.aluguer ?? false) && (
                                            <th scope="col" className="px-6 py-3">
                                                {t('iva')}
                                            </th>
                                        )} */}
                                        <th scope="col" className="px-6 py-3">
                                            {t('quantidade')}
                                        </th>

                                        {!(tipoOrcamento?.aluguer ?? false) && (
                                            <th scope="col" className="px-6 py-3">
                                                {t('preco')}
                                            </th>
                                        )}

                                        {!(tipoOrcamento?.aluguer ?? false) && (
                                            <th scope="col" className="px-6 py-3">
                                                {t('desconto')}
                                            </th>
                                        )}
                                        {!(tipoOrcamento?.aluguer ?? false) && (
                                            <th scope="col" className="px-6 py-3">
                                                {t('total')}
                                            </th>
                                        )}
                                        {!(tipoOrcamento?.aluguer ?? false) && (
                                            <th scope="col" className="px-6 py-3">
                                                {t('totalCExtras')}
                                            </th>
                                        )}
                                        <th scope="col" className="px-6 py-3"></th>
                                    </tr>
                                </thead>
                                <tbody>{memoizedData}</tbody>
                            </table>
                        </div>
                    </form>
                    <div className="flex flex-row-reverse justify-between">
                        {!(tipoOrcamento?.aluguer ?? false) && (
                            <>
                                <div className=" static  h-3/6 w-1/3 ml-auto">
                                    <div className=" flex flex-row text-left justify-between ">
                                        <p className=" font-medium text-lg mr-15 text-gray-900 dark:text-white">{t('subtotal')}</p>

                                        <p className="text-lg font-medium text-gray-900 dark:text-white">{formatarNumero(subtotal)}</p>
                                    </div>
                                    <div className=" flex flex-row text-left justify-between ">
                                        <p className=" font-medium text-lg mr-15 text-gray-900 dark:text-white">{t('totalDesconto')}</p>

                                        <p className="text-lg font-medium text-gray-900 dark:text-white">{formatarNumero(totalDesconto)}</p>
                                    </div>

                                    {/* <div className=" flex flex-row text-left justify-between ">
                                        <p className=" font-medium text-lg mr-15 text-gray-900 dark:text-white">{t('iva')}</p>

                                        <p className="text-lg font-medium text-gray-900 dark:text-white">{formatarNumero(totalIVA)}</p>
                                    </div> */}
                                    <div className=" flex flex-row justify-between">
                                        <p className="text-lg font-medium mr-15 text-gray-900 dark:text-white ">{t('total')}</p>
                                        <p className="text-lg font-medium text-gray-900 dark:text-white ">{formatarNumero(subtotal - totalDesconto + totalIVA)}</p>
                                    </div>
                                    <div className="flex flex-row justify-end ">
                                        <div className="border-b dark:border-white w-[450px] border-black my-4"></div>
                                    </div>
                                </div>
                            </>
                        )}

                        {(propostaCarregada?.aprovadoRep > 1 || propostaCarregada?.aprovadoAdmin > 1) && (
                            <div className=" static  h-3/6 w-1/3 ">
                                {/* {propostaCarregada?.aprovadoRep > 1 && (
                                    <>
                                        <div className=" flex flex-row text-left justify-between ">
                                            <p className=" font-medium text-lg mr-15 text-gray-900 dark:text-white">{t('aprovadoRep')}</p>
                                            <p className={`text-lg font-bold text-right text-blue-600 dark:text-blue-400`}>{propostaCarregada?.aprovadoRepDescicao}</p>
                                        </div>
                                        {propostaCarregada?.aprovadoRep === 2 && (
                                            <div className=" flex flex-row text-left justify-between ">
                                                <p className=" font-medium text-lg mr-15 text-gray-900 dark:text-white">{t('motivoNAprovacao')}</p>
                                                <p className="text-lg text-right font-normal text-gray-900 max-w-3/4 dark:text-white">{propostaCarregada?.motivoNaoAprovacaoRep}</p>
                                            </div>
                                        )}
                                    </>
                                )} */}

                                {propostaCarregada?.aprovadoAdmin > 1 && (
                                    <>
                                        <div className=" flex flex-row text-left justify-between ">
                                            <p className=" font-medium text-lg mr-15 text-gray-900 dark:text-white">{t('aprovadoAdmin')}</p>
                                            <p className="text-lg font-bold text-right text-blue-600  dark:text-blue-400">{propostaCarregada?.aprovadoAdminDescicao}</p>
                                        </div>
                                        {propostaCarregada?.aprovadoAdmin === 2 && (
                                            <div className=" flex flex-row justify-between">
                                                <p className="text-lg font-medium mr-20 text-gray-900 dark:text-white  ">{t('motivoNAprovacao')}</p>
                                                <p className="text-lg font-normal text-right text-gray-900 dark:text-white max-w-3/4">{propostaCarregada?.motivoNaoAprovacaoAdmin}</p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </>
            )}

            {openTab === 2 && (
                <Geral
                    editarProposta={editarProposta}
                    layout={layout}
                    setLayout={setLayout}
                    arrayLayout={arrayLayout}
                    textoIntro={textoIntro}
                    setTextoIntro={setTextoIntro}
                    textosIntro={textosIntro}
                    textoDespedida={textoDespedida}
                    setTextoDespedida={setTextoDespedida}
                    arrayTextoDespedida={arrayTextoDespedida}
                    setOnChangeForm={setOnChangeForm}
                    prazoEntrega={prazoEntrega}
                    setPrazoEntrega={setPrazoEntrega}
                    arrayLocalEntrega={arrayLocalEntrega}
                    setLocalEntrega={setLocalEntrega}
                    localEntrega={localEntrega}
                    validadeProposta={validadeProposta}
                    setValidadeProposta={setValidadeProposta}
                    setObservacoes={setObservacoes}
                    observacoes={observacoes}
                    contactoAssinatura={contactoAssinatura}
                    setContactoAssinatura={setContactoAssinatura}
                    acrescimoIVA={acrescimoIVA}
                    setAcrescimoIVA={setAcrescimoIVA}
                    ecovalor={ecovalor}
                    setEcovalor={setEcovalor}
                    ecolub={ecolub}
                    setEcolub={setEcolub}
                    ecobat={ecobat}
                    setEcobat={setEcobat}
                    arrayPrazosEntrega={arrayPrazosEntrega}
                    arrayValidadeProposta={arrayValidadeProposta}
                />
            )}

            {openTab === 3 && (
                <Pagamento
                    editarProposta={editarProposta}
                    condicoesPagamento={condicoesPagamento}
                    descricaoOutros={descricaoOutros}
                    setDescricaoOutros={setDescricaoOutros}
                    setCondicoesPagamento={setCondicoesPagamento}
                    arrayCondicoesPagamento={arrayCondicoesPagamento}
                    setOnChangeForm={setOnChangeForm}
                    setValidacaoCondicoesPagamento={setValidacaoCondicoesPagamento}
                    validacaoCondicoesPagamento={validacaoCondicoesPagamento}
                />
            )}
            {openTab === 4 && (
                <Garantia
                    editarProposta={editarProposta}
                    arrayGarantia={arrayGarantia}
                    arrayGarantiaMotor={arrayGarantiaMotor}
                    arrayGarantiaPower={arrayGarantiaPower}
                    garantia={garantia}
                    setGarantia={setGarantia}
                    garantiaMotor={garantiaMotor}
                    setGarantiaMotor={setGarantiaMotor}
                    garantiaPower={garantiaPower}
                    setGarantiaPower={setGarantiaPower}
                    setOnChangeForm={setOnChangeForm}
                />
            )}
            {openTab === 5 && (
                <Manutencao
                    editarProposta={editarProposta}
                    tipoContrato={tipoContrato}
                    setTipoContrato={setTipoContrato}
                    arrayTipoContrato={arrayTipoContrato}
                    lubrificantes={lubrificantes}
                    setLubrificantes={setLubrificantes}
                    arrayLubrificantes={arrayLubrificantes}
                    duracaoContrato={duracaoContrato}
                    setDuracaoContrato={setDuracaoContrato}
                    arrayDuracaoContrato={arrayDuracaoContrato}
                    arrayHorasAno={arrayHorasAno}
                    horasAno={horasAno}
                    setHorasAno={setHorasAno}
                    localTrabalho={localTrabalho}
                    setLocalTrabalho={setLocalTrabalho}
                    setOnChangeForm={setOnChangeForm}
                />
            )}
            {openTab === 6 && (
                <Retoma
                    marcas={marcas}
                    editarProposta={editarProposta}
                    tipoContrato={tipoContrato}
                    setTipoContrato={setTipoContrato}
                    arrayTipoContrato={arrayTipoContrato}
                    lubrificantes={lubrificantes}
                    setLubrificantes={setLubrificantes}
                    arrayLubrificantes={arrayLubrificantes}
                    duracaoContrato={duracaoContrato}
                    setDuracaoContrato={setDuracaoContrato}
                    arrayDuracaoContrato={arrayDuracaoContrato}
                    arrayHorasAno={arrayHorasAno}
                    horasAno={horasAno}
                    setHorasAno={setHorasAno}
                    localTrabalho={localTrabalho}
                    setLocalTrabalho={setLocalTrabalho}
                    setOnChangeForm={setOnChangeForm}
                    //
                    setLinhasRetoma={setLinhasRetoma}
                    linhasRetoma={linhasRetoma}
                    categorias={categorias}
                    validacaoModelo={validacaoModelo}
                    setValidacaoModelo={setValidacaoModelo}
                    validacaoNserie={validacaoNserie}
                    setValidacaoNserie={setValidacaoNserie}
                    validacaoMatricula={validacaoMatricula}
                    setValidacaoMatricula={setValidacaoMatricula}
                    validacaoHoras={validacaoHoras}
                    setValidacaoHoras={setValidacaoHoras}
                    validacaoAno={validacaoAno}
                    setValidacaoAno={setValidacaoAno}
                    validacaoValor={validacaoValor}
                    setValidacaoValor={setValidacaoValor}
                />
            )}
            {openTab === 7 && (
                <Status
                    proposta={proposta}
                    // filtro status
                    filtroDtStatus={filtroDtStatus}
                    setFiltroDtStatus={setFiltroDtStatus}
                    filtroUtilizador={filtroUtilizador}
                    setFiltroUtilizador={setFiltroUtilizador}
                    filtroAcao={filtroAcao}
                    setFiltroAcao={setFiltroAcao}
                    filtroDestinatarios={filtroDestinatarios}
                    setFiltroDestinatarios={setFiltroDestinatarios}
                    filtroEmail={filtroEmail}
                    setFiltroEmail={setFiltroEmail}
                    statusOcamento={statusOcamento}
                />
            )}
            {openTab === 8 && (
                <PA
                    marcas={marcas}
                    editarProposta={editarProposta}
                    tipoContrato={tipoContrato}
                    setTipoContrato={setTipoContrato}
                    arrayTipoContrato={arrayTipoContrato}
                    lubrificantes={lubrificantes}
                    setLubrificantes={setLubrificantes}
                    arrayLubrificantes={arrayLubrificantes}
                    duracaoContrato={duracaoContrato}
                    setDuracaoContrato={setDuracaoContrato}
                    arrayDuracaoContrato={arrayDuracaoContrato}
                    arrayHorasAno={arrayHorasAno}
                    horasAno={horasAno}
                    setHorasAno={setHorasAno}
                    localTrabalho={localTrabalho}
                    setLocalTrabalho={setLocalTrabalho}
                    setOnChangeForm={setOnChangeForm}
                    //
                    setPontosAnalise={setPontosAnalise}
                    pontosAnalise={pontosAnalise}
                    arrayPontosAnalise={arrayPontosAnalise}
                />
            )}

            {/* Separador de Contrato Financeiro */}
            {openTab === 9 && (
                <ContratoFinanceiro
                    condicoesPagamento={condicoesPagamentoCF}
                    setCondicoesPagamento={setCondicoesPagamentoCF}
                    editarProposta={editarProposta}
                    setOnChangeForm={setOnChangeForm}
                    // novos campos
                    duracao={duracao}
                    setDuracao={setDuracao}
                    carencia={carencia}
                    setCarencia={setCarencia}
                    numRendas={numRendas}
                    setNumRendas={setNumRendas}
                    portesMes={portesMes}
                    setPortesMes={setPortesMes}
                    seguroCivil={seguroCivil}
                    setSeguroCivil={setSeguroCivil}
                    taxaNominal={taxaNominal}
                    setTaxaNominal={setTaxaNominal}
                    entradaInicial={entradaInicial}
                    setEntradaInicial={setEntradaInicial}
                    rendaMensal={rendaMensal}
                    setRendaMensal={setRendaMensal}
                    valorResidual={valorResidual}
                    setValorResidual={setValorResidual}
                    seguroCasco={seguroCasco}
                    setSeguroCasco={setSeguroCasco}
                    despesasContrato={despesasContrato}
                    setDespesasContrato={setDespesasContrato}
                    //Arrays
                    arrayCondicoesPagamento={arrayCondicoesPagamento}
                    arrayDuracao={arrayDuracao}
                    arrayCarencia={arrayCarencia}
                    arrayNumRendas={arrayNumRendas}
                    arrayPortesMes={arrayPortesMes}
                    arraySeguroCivil={arraySeguroCivil}
                    arrayTaxaNominal={arrayTaxaNominal}
                    arrayEntradaInicial={arrayEntradaInicial}
                    arrayRendaMensal={arrayRendaMensal}
                    arrayValorResidual={arrayValorResidual}
                    arraySeguroCasco={arraySeguroCasco}
                    arrayDespesasContrato={arrayDespesasContrato}
                    setArrayDuracao={setArrayDuracao}
                    setArrayCarencia={setArrayCarencia}
                    setArrayNumRendas={setArrayNumRendas}
                    setArrayPortesMes={setArrayPortesMes}
                    setArraySeguroCivil={setArraySeguroCivil}
                    setArrayTaxaNominal={setArrayTaxaNominal}
                    setArrayEntradaInicial={setArrayEntradaInicial}
                    setArrayRendaMensal={setArrayRendaMensal}
                    setArrayValorResidual={setArrayValorResidual}
                    setArraySeguroCasco={setArraySeguroCasco}
                    setArrayDespesasContrato={setArrayDespesasContrato}
                />
            )}
            {showExitModal && (
                <ExitForm
                    cancelar={() => setShowExitModal(false)}
                    back={() => {
                        setShowForm(false);
                        setShowExitModal(false);
                        setEditarProposta(false);
                    }}
                />
            )}
        </>
    );
}

export default NovaProposta;
